module.exports = __webpack_public_path__ + "images/emoji/swimmer.b3a2c66200dbb790e9bd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/swimmer.png
// module id = 2e6/
// module chunks = 1